import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import EventTableRow from "src/components/FairEventComponents/EventTableRow";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { IFairAllEvents } from "src/Types/module/FairEvent/FairEventType";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";

const AllEventList = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [status, setStatus] = useState<string>("upcoming");
	const [searchValue, setSearchValue] = useState<string>("");
	const { data: allEvents, isLoading } = useGetQueryWithTotal<
		IFairAllEvents[]
	>({
		endPoint: `/api/fair/event`,
		queryKeys: ["AllEvents", searchValue, status],
		params: { status: status, ...pagination, name: searchValue },
	});

	return (
		<CommCard
			headerTitle={`All Event List (${allEvents?.total || 0})`}
			helmetTitle='BTTF - All Event list'
			showCardHeader
			showSearch
			handleSearchFun={(value) => setSearchValue(value)}
			statusOptions={[
				{
					id: "all",
					name: "All",
				},
				{
					id: "upcoming",
					name: "Upcoming",
				},
				{
					id: "ended",
					name: "Ended",
				},
				{
					id: "rejected",
					name: "Rejected",
				},
			]}
			handleSelectStatus={(status) => setStatus(status)}
			showStatus
		>
			<TableContainer>
				<Table sx={{ position: "relative", minHeight: "250px" }}>
					<TableHead>
						<TableRow>
							<TableCell align='center'>SL.</TableCell>
							<TableCell align='center'>Event Title</TableCell>
							<TableCell align='center'>Event Venue</TableCell>
							<TableCell align='center'>Event Date</TableCell>
							<TableCell align='center'>Event Photo</TableCell>
							<TableCell align='center'>Event Status</TableCell>
							<TableCell align='center'>Action</TableCell>
						</TableRow>
					</TableHead>
					{isLoading ? (
						<TableLoader />
					) : allEvents?.data?.length ? (
						<TableBody>
							{allEvents?.data?.map((sEvent, idx) => {
								return (
									<EventTableRow
										key={sEvent.event_id}
										sEvent={sEvent}
										serial={idx + 1}
									/>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
			</TableContainer>
			<Box p={2}>
				<CommonPagination
					total={allEvents?.total}
					paginationCalFun={(limit: number, skip: number) => {
						setPagination({ limit, skip });
					}}
				/>
			</Box>
		</CommCard>
	);
};

export default AllEventList;
